import { Tooltip } from "react-bootstrap"
import React from "react"
import dayjs from "dayjs"
import PortalUserRoleTypes from "src/pages/hr/Types/PortalUserRoleTypes"
import RoleAssignmentHashTableTypes from "src/pages/hr/Types/RoleAssignmentHashTableTypes"
import RoleTemplateTypes from "src/pages/hr/Types/RoleTemplateTypes"
import RoleTypes from "src/pages/hr/Types/RoleTypes"
import portalUserRoleBoilerplate from "./boilerplates/PortalUserRoleBoilerplate"
import handleAddOrDropEdit from "./HandleAddOrDropEdit"
import handleAddOrDropRole from "./HandleAddOrDropRole"
import handleAddOrDropView from "./HandleAddOrDropView"
import hashTable from "./hashTable"
import RoleTemplatePortalRoleLnkTypes from "src/pages/hr/Types/RoleTemplatePortalRoleLnkTypes"

const storageSize = 2500
const ht = new hashTable(storageSize)
const date = new Date()

const roleAssignmentHelper = {
    timeZoneOffset: -date.getTimezoneOffset(),
    timeFormat: "MM/DD/YY h:mm a",
    allRolesCopy: [],
    grantedRolesCopy: [],
    roleTableItems: [
        { title: "Name", key: "RoleName", order: 1, isCheckBox: false, isDate: false, popover: false, popover2: false, width: "100px" },
        { title: "Description", key: "Description", order: 2, isCheckBox: false, isDate: false, popover: true, popover2: true, width: null },
        { title: "Protected", key: "IsProtected", order: 3, isCheckBox: true, isDate: false, popover: false, popover2: false, width: null }
    ].sort(({ order: a }, { order: b }) => a - b),
    buildHashTable: (grantedRoles: PortalUserRoleTypes[], allRoles: PortalUserRoleTypes[]) => {
        ht.purgeTable(false)
        roleAssignmentHelper.setAllRolesCopy(allRoles)
        roleAssignmentHelper.setGrantedRolesCopy(grantedRoles)
        const joined: PortalUserRoleTypes[] = allRoles.concat(grantedRoles)
        for (let i = 0; i < joined.length; i++) {
            const id = joined[i].PortalRoleId
            let existingNode = ht.lookupItem([`${id}`])
            if (!existingNode) {
                ht.addItem([`${id}`, { hasRole: false, addRole: false, dropRole: false, hasView: false, addView: false, dropView: false, hasEdit: false, addEdit: false, dropEdit: false }])
            } else {
                existingNode[1] = { hasRole: true, addRole: false, dropRole: false, hasView: joined[i].View, addView: false, dropView: false, hasEdit: joined[i].Edit, addEdit: false, dropEdit: false }
                ht.updateItem(existingNode)
            }
        }
        const storage = ht.getStorage()
        return storage
    },
    getStorage: () => {
        const storage = ht.getStorage()
        return storage
    },
    setAllRolesCopy: (allRoles: PortalUserRoleTypes[]) => {
        //@ts-ignore
        roleAssignmentHelper.allRolesCopy = allRoles
    },
    getAllRolesCopy: () => {
        return roleAssignmentHelper.allRolesCopy
    },
    setGrantedRolesCopy: (grantedRoles: PortalUserRoleTypes[]) => {
        //@ts-ignore
        roleAssignmentHelper.grantedRolesCopy = grantedRoles
    },
    getGrantedRolesCopy: () => {
        return roleAssignmentHelper.grantedRolesCopy
    },
    lookupHashTableItem: (id: number) => {
        const item = ht.lookupItem([`${id}`])
        return item
    },
    updateHashTableItem: (bucketItem: RoleAssignmentHashTableTypes) => {
        ht.updateItem(bucketItem)
    },
    addHashTableItem: (bucketItem: RoleAssignmentHashTableTypes) => {
        ht.addItem(bucketItem)
    },
    deleteHashTableItem: (bucketItem: RoleAssignmentHashTableTypes) => {
        ht.deleteItem(bucketItem[0])
    },
    checkOrUncheckAll: (roles: RoleTypes[], all: boolean) => {
        for (let i = 0; i < roles.length; i++) {
            const bucketItem = roleAssignmentHelper.lookupHashTableItem(roles[i].PortalRoleId)
            const operation = all ? "all" : "!all"
            roleAssignmentHelper.addOrDropRole(bucketItem, operation)
        }
    },
    addOrRemoveTemplate: (roleLinks: RoleTemplatePortalRoleLnkTypes[], operation: "+" | "-") => {
        console.log(roleLinks)
        roleAssignmentHelper.buildHashTable(roleAssignmentHelper.getGrantedRolesCopy(), roleAssignmentHelper.getAllRolesCopy())
        for (let i = 0; i < roleLinks.length; i++) {
            const bucketItem: RoleAssignmentHashTableTypes = roleAssignmentHelper.lookupHashTableItem(roleLinks[i].PortalRoleId)
            if(bucketItem){
                let newItem: RoleAssignmentHashTableTypes = JSON.parse(JSON.stringify(bucketItem))
                newItem[1].addRole = newItem[1].hasRole ? false : true
                newItem[1].addView = newItem[1].hasView ? false : roleLinks[i].View
                newItem[1].addEdit = newItem[1].hasEdit ? false : roleLinks[i].Edit
                roleAssignmentHelper.updateHashTableItem(newItem)
            }
        }
        return roleAssignmentHelper.getStorage()
    },
    addOrDropRole: (bucketItem: RoleAssignmentHashTableTypes, operation?: "+" | "-" | "all" | "!all") => {
        handleAddOrDropRole(bucketItem, operation)
    },
    addOrDropView: (bucketItem: RoleAssignmentHashTableTypes, operation?: "+" | "-" | "all" | "!all") => {
        handleAddOrDropView(bucketItem, operation)
    },
    addOrDropEdit: (bucketItem: RoleAssignmentHashTableTypes, operation?: "+" | "-" | "all" | "!all") => {
        handleAddOrDropEdit(bucketItem, operation)
    },
    findTemplateMatch: (templates: RoleTemplateTypes[]) => {
        for (let i = 0; i < templates.length; i++) {
            let count = 0
            for (let j = 0; j < templates[i].RoleTemplatePortalRoleLnk.length; j++) {
                const bucketItem = roleAssignmentHelper.lookupHashTableItem(templates[i].RoleTemplatePortalRoleLnk[j].PortalRoleId)
                if (bucketItem[1].hasRole) {
                    count++
                }
            }
            if (count === templates[i].RoleTemplatePortalRoleLnk.length) {
                return i
            }
        }
        return -1
    },
    checkIfHasRole: (role: PortalUserRoleTypes) => {
        const grantedRoles: PortalUserRoleTypes[] = roleAssignmentHelper.getGrantedRolesCopy()
        for (let i = 0; i < grantedRoles.length; i++) {
            if (role.PortalRoleId === grantedRoles[i].PortalRoleId) {
                return true
            }
        }
        return
    },
    saveSetup: (targetedUserId: string | number, loggedInUserId: string | number) => {
        let roles: PortalUserRoleTypes[] = roleAssignmentHelper.getAllRolesCopy()
        let payload: PortalUserRoleTypes[] = []
        const date = dayjs().format()
        for (let i = 0; i < roles.length; i++) {
            const bucketItem: RoleAssignmentHashTableTypes[1] = roleAssignmentHelper.lookupHashTableItem(roles[i].PortalRoleId)[1]
            if (bucketItem.addRole || bucketItem.dropRole || bucketItem.addEdit || bucketItem.dropEdit || bucketItem.addView || bucketItem.dropView) {
                let role = { ...roles[i] }
                let boilerblate = { ...portalUserRoleBoilerplate }
                boilerblate.UserId = targetedUserId
                boilerblate.PortalRoleId = role.PortalRoleId
                boilerblate.DeletedDate = !bucketItem.dropRole ? null : date
                if (roleAssignmentHelper.checkIfHasRole(role)) {
                    boilerblate.ModifiedBy = `${loggedInUserId}`
                    boilerblate.ModifyDate = date
                } else {
                    boilerblate.CreatedBy = `${loggedInUserId}`
                    boilerblate.CreatedDate = date
                }
                boilerblate.View = ((bucketItem.hasView || bucketItem.addView) && !bucketItem.dropView) ? true : bucketItem.dropView ? false : role.View
                boilerblate.Edit = ((bucketItem.hasEdit || bucketItem.addEdit) && !bucketItem.dropEdit) ? true : bucketItem.dropEdit ? false : role.Edit
                payload.push(boilerblate)
            }
        }
        return { Roles: payload, TargetedUserId: targetedUserId }
    },
    rasTooltip: (text: string) => (
        <Tooltip id={`ras-tooltip`}>
            {text}
        </Tooltip>
    )
}

export default roleAssignmentHelper